import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { Icons } from 'greener-ui-library';

export default function TopBarSearch({ openSearchDrawer }: { openSearchDrawer: (open: boolean) => void }) {
  const { t } = useTranslation();
  return (
    <Tooltip title={t('navigation.search')}>
      <IconButton data-testid="top-bar-search" color="inherit" onClick={() => openSearchDrawer(true)}>
        <Icons.Search />
      </IconButton>
    </Tooltip>
  );
}
